import useFavorites from '@hooks/useFavorites';
import { SAVED_COMPANIES_QUERY, SAVE_COMPANY, REMOVE_COMPANY } from '@general/graphql/company.graph';
import { SAVED_EVENTS_QUERY, SAVE_EVENT, REMOVE_EVENT } from '@general/graphql/event.graph';
import { SAVED_SESSIONS_QUERY, SAVE_SESSION, REMOVE_SESSION } from '@general/graphql/session.graph';
import { SAVED_ARTICLES_QUERY, SAVE_ARTICLE, REMOVE_ARTICLE } from '@general/graphql/article.graph';
import { SAVED_CONTACTS_RECORD_ID_QUERY, SAVE_CONTACT, REMOVE_CONTACT } from '@general/graphql/contact.graph';
import { SAVED_PUBLICATIONS_QUERY, SAVE_PUBLICATION, REMOVE_PUBLICATION } from '@general/graphql/publication.graph';
import { FAVORITE_PROPERTY, SAVED_PROPERTIES_QUERY, UNFAVORITE_PROPERTY } from '@general/graphql/properties.graph';

/**
 * @param {Object} opts
 * @param {string} opts.type company|event|session|article|contact|publication
 * @param {boolean} opts.initialIsFavorite Initial value for isFavorite
 * @param {Object} opts.readItemQuery Override default read query - used in sprinkle favorites
 *      readItemQuery must match query that originally fetched the items (for cache).
 */
const getFavoriteHook = ({ type, initialIsFavorite, readItemQuery }) => {
    if (type === 'company') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_COMPANIES_QUERY,
                saveQuery: SAVE_COMPANY,
                removeQuery: REMOVE_COMPANY,
                type: 'company',
                typePlural: 'companies',
                saveMutationName: 'saveCompany',
                initialIsFavorite,
            });
    }
    if (type === 'event') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_EVENTS_QUERY,
                saveQuery: SAVE_EVENT,
                removeQuery: REMOVE_EVENT,
                type: 'event',
                typePlural: 'viewerEvents',
                saveMutationName: 'saveEvent',
                initialIsFavorite,
            });
    }
    if (type === 'session') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_SESSIONS_QUERY,
                saveQuery: SAVE_SESSION,
                removeQuery: REMOVE_SESSION,
                type: 'session',
                typePlural: 'sessions',
                saveMutationName: 'saveSession',
                initialIsFavorite,
            });
    }
    if (type === 'article') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_ARTICLES_QUERY,
                saveQuery: SAVE_ARTICLE,
                removeQuery: REMOVE_ARTICLE,
                type: 'article',
                typePlural: 'articles',
                saveMutationName: 'saveArticle',
                initialIsFavorite,
            });
    }
    if (type === 'contact' || type === 'member') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_CONTACTS_RECORD_ID_QUERY,
                saveQuery: SAVE_CONTACT,
                removeQuery: REMOVE_CONTACT,
                type: 'contact',
                typePlural: 'contacts',
                saveMutationName: 'saveContact',
                initialIsFavorite,
            });
    }
    if (type === 'publication') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_PUBLICATIONS_QUERY,
                saveQuery: SAVE_PUBLICATION,
                removeQuery: REMOVE_PUBLICATION,
                type: 'publication',
                typePlural: 'publications',
                saveMutationName: 'savePublication',
                initialIsFavorite,
            });
    }
    if (type === 'property') {
        return () =>
            useFavorites({
                readItemQuery: readItemQuery || SAVED_PROPERTIES_QUERY,
                saveQuery: FAVORITE_PROPERTY,
                removeQuery: UNFAVORITE_PROPERTY,
                type: 'property',
                typePlural: 'savedProperties',
                saveMutationName: 'saveProperty',
                initialIsFavorite,
            });
    }

    console.log(`This type: ${type} needs a favoriting hook`);
};

export default getFavoriteHook;
